import { useActionItem } from '@workboard/action-item';
import merge from 'lodash/merge';
import { useMemo, useCallback, useState } from 'react';
import { AiWorkstreamData } from '../ActionItemPopup/types';
import { useAxios } from '../hooks/useAxios';
import { useNotification } from '../notifications';

export const useWorkstreamInfo = ({ aiId }) => {
  const { changeWorkstream, changeWorkstreamColumn } = useActionItem(aiId);
  const notify = useNotification();
  const [filter, setFilter] = useState<string>('');

  const [{ data: workstreams, loading, error }] = useAxios({
    url: 'activity/ViewWorkstreamList',
    method: 'GET',
    params: {
      act_id: aiId,
      show_search: true,
      json: true,
    },
  });

  const options = useMemo(() => {
    const mergedWorkstreams = {};
    const result: AiWorkstreamData[] = [];
    Object.values<AiWorkstreamData>(workstreams?.data || {}).forEach((val) => {
      Object.values<AiWorkstreamData>(val as any).forEach((v) => {
        if ('ws' in v) {
          merge(mergedWorkstreams, v.ws);
        } else {
          merge(mergedWorkstreams, val);
        }
      });
    });
    Object.values(mergedWorkstreams).forEach((ws: AiWorkstreamData) => {
      result.push(ws);
    });

    return result
      .filter(
        (o) =>
          o.name.toLowerCase().includes(filter.toLowerCase()) ||
          o.tname.toLowerCase().includes(filter.toLowerCase())
      )
      .map((o) => ({ ...o, label: o.name }));
  }, [workstreams, filter]);

  const handleWorkstreamChange = async (_e, ws) => {
    await changeWorkstream.mutateAsync({
      id: ws.id,
      title: ws.label,
      tname: ws.tname,
      boardType: '' as any,
    });
  };

  const handleSearch = (text) => {
    setFilter(text);
  };

  const postWsColumn = changeWorkstreamColumn.mutateAsync;
  const handleWorkstreamColumn = useCallback(
    async (columnId: string) => {
      try {
        await postWsColumn({
          id: columnId,
          title: '',
        });
      } catch (e) {
        notify.error('Could not save the data. Please try again later');
      }
    },
    [postWsColumn, notify]
  );

  return {
    options,
    loading,
    error,
    handleSearch,
    handleWorkstreamChange,
    handleWorkstreamColumn,
  };
};
